//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "book"
}



// WEBPACK FOOTER //
// ./src/components/book/book.vue